var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProdMs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 61,
    viewBox: "0 0 70 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_213",
    "data-name": "Group 213",
    transform: "translate(-414 -573)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_113",
    "data-name": "Rectangle 113",
    width: 70,
    height: 61,
    rx: 24,
    transform: "translate(414 573)",
    fill: "#f8f9fa"
  }), /*#__PURE__*/React.createElement("text", {
    id: "MS",
    transform: "translate(449 614)",
    fill: "#3f4055",
    fontSize: 32,
    fontFamily: "MyriadPro-Bold, Myriad Pro",
    fontWeight: 700,
    letterSpacing: "0.05em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -22.976,
    y: 0
  }, "MS")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProdMs);
export default __webpack_public_path__ + "static/media/prodMS.35014dafbb1e704208100b840062ee05.svg";
export { ForwardRef as ReactComponent };